
import React from 'react';
import { ExamResult } from '@/utils/exam/types';
import { useExamResultForm, examTypes } from '@/hooks/useExamResultForm';

// Import components
import ExamFormHeader from '@/components/student-exams/ExamFormHeader';
import ExamDetailsFields from '@/components/student-exams/ExamDetailsFields';
import ExamScoreFields from '@/components/student-exams/ExamScoreFields';
import ExamAdditionalFields from '@/components/student-exams/ExamAdditionalFields';
import ExamFormActions from '@/components/student-exams/ExamFormActions';

const ExamResultForm = () => {
  const {
    register,
    errors,
    touchedFields,
    formSubmitted,
    handleSubmit,
    setValue,
    watch,
    onSubmit,
    handleCancel,
    isSubmitting,
    isEditMode,
    watchObtainedScore,
    watchMaxScore,
    percentage,
    studentPrograms
  } = useExamResultForm();

  return (
    <div className="w-full">
      <div className="max-w-4xl mx-auto bg-background rounded-lg border shadow-sm">
        <ExamFormHeader 
          isEditMode={isEditMode} 
          onCancel={handleCancel} 
        />

        <form onSubmit={handleSubmit(onSubmit)} className="p-6 space-y-6">
          <ExamDetailsFields 
            register={register}
            errors={errors}
            setValue={setValue}
            watch={watch}
            examTypes={examTypes}
            formSubmitted={formSubmitted}
            touchedFields={touchedFields}
            studentPrograms={studentPrograms}
          />

          <ExamScoreFields 
            register={register}
            errors={errors}
            watchObtainedScore={watchObtainedScore}
            watchMaxScore={watchMaxScore}
            percentage={percentage}
            setValue={setValue}
            formSubmitted={formSubmitted}
            touchedFields={touchedFields}
            studentPrograms={studentPrograms}
          />

          <ExamAdditionalFields 
            register={register}
          />

          <ExamFormActions 
            isSubmitting={isSubmitting}
            isEditMode={isEditMode}
            onCancel={handleCancel}
          />
        </form>
      </div>
    </div>
  );
};

export default ExamResultForm;
